import {otsBaseApi} from "../../ots-api";
import {LocationStatusFacet} from "../../../model/service/location-status-facet";
import {removeUndefined} from "../../../util/util";
import {ServiceEventType} from "../../../model/service/service-event-type";

const ALL_TAG_TYPES = [
  "LocationStatusFacets",
  "ObjectObjectChangeLogs",
] as const;

type TagType = typeof ALL_TAG_TYPES[number];

const taggedBaseApi = otsBaseApi.enhanceEndpoints({
  addTagTypes: ALL_TAG_TYPES
});

const locationStatusFacetApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLocationStatusFacetsAtTime: builder.query<
      LocationStatusFacet[],
      {
        regionId: string,
        dttm?: number,
        serviceEventType?: ServiceEventType
        serviceEventId?: string
        serviceTypeId?: string
        statusFacet?: string
        status?: string
        serviceMode?: string
        siteIds?: string[]
      }
    >({
      query: (criteria) => ({
        url: `/location-status-facets/at`,
        method: 'GET',
        params: removeUndefined({
          asOf: criteria.dttm,
          regionId: criteria.regionId,
          serviceEventType: criteria.serviceEventType?.code,
          serviceEventId: criteria.serviceEventId,
          serviceTypeId: criteria.serviceTypeId,
          statusFacet: criteria.statusFacet,
          status: criteria.status,
          serviceMode: criteria.serviceMode,
          siteIds: criteria.siteIds,
        }),
      }),
    }),
    getLocationStatusFacet: builder.query<LocationStatusFacet, string>({
      query: (id) => ({
        url: `/location-status-facets/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{type: "LocationStatusFacets", id}]
    }),
    createLocationStatusFacet: builder.mutation<LocationStatusFacet, Partial<LocationStatusFacet>>({
      query: (event) => ({
        url: "/location-status-facets",
        method: "POST",
        body: event
      }),
      invalidatesTags: [{type: "LocationStatusFacets", id: "LIST"}]
    }),
    updateLocationStatusFacet: builder.mutation<LocationStatusFacet, Partial<LocationStatusFacet>>({
      query: (event) => ({
        url: "/location-status-facets",
        method: "PUT",
        body: event,
      }),
      invalidatesTags: (result, error, {id}) => [
        {type: "LocationStatusFacets", id},
        {type: "ObjectObjectChangeLogs", id}
      ]
    }),
    deleteLocationStatusFacet: builder.mutation<void, Partial<LocationStatusFacet>>({
      query: (event) => ({
        url: "/location-status-facets",
        method: "DELETE",
        body: event
      }),
      invalidatesTags: (result, error, {id}) => [{type: "LocationStatusFacets", id}]
    }),
  })
});

export const {
  useGetLocationStatusFacetsAtTimeQuery,
  useGetLocationStatusFacetQuery,
  useCreateLocationStatusFacetMutation,
  useUpdateLocationStatusFacetMutation,
  useDeleteLocationStatusFacetMutation,
} = locationStatusFacetApi;
